import { render, staticRenderFns } from "./WhiteLabelCustomers.vue?vue&type=template&id=59740f9f&"
import script from "./WhiteLabelCustomers.vue?vue&type=script&lang=js&"
export * from "./WhiteLabelCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports